import { render } from "./IconHeartOutlined.vue?vue&type=template&id=d332b61a"
import script from "./IconHeartOutlined.vue?vue&type=script&lang=js"
export * from "./IconHeartOutlined.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__